import {isApiTrue}         from "@Common/logic/is-api-true";
import {sort, sum, unique} from "@Common/utils/collections";
import {chain}             from "@Common/utils/fs";
import {capitalize}        from "@Common/utils/strings";

export const getPurchaseMlSummaryLines = ({templateOptions, mailingLists, isMailing, isAddressableShipping}) => {
    if (!mailingLists?.length) {
        return [];
    }
    const prices = templateOptions?.options
        .find((option) => (option.group==="lineItem" && option.dev_key==="address_lists"))
        ?.flatPrice
    ;
    if (!prices) {
        return [];
    }
    const mls = mailingLists?.filter((ml) => (
        ml.count &&
        (isApiTrue(ml.purchaseRequired) || ml.listTypeId === 6) &&
        (
            isMailing ||
            isAddressableShipping ||
            ml.unitPrice > 0
        )
    ));

    return chain(
        mls.map((ml) => ml.listTypeId),
        unique,
        sort,
        (_) => _.map((typeId) => {

            const mls1 = mls.filter((ml) => ml.listTypeId === typeId);

            return ({
                label: (
                    capitalize(mls1[0].type) +
                    " - " +
                    mls1.map((ml) => ml.mailingListName).join(", ") +
                    ""
                ),
                qty: sum(mls1, (ml) => +ml.count),
                unitPrice: prices[typeId],
            });
        }),
    );
};

